<div class="modal-header justify-content-center">
    <h4 class="modal-title">{{'MAIL_SENT_SUCCESSFULLY' | translate}}</h4>
</div>
<div class="modal-body text-center">{{ 'FORGOT_PSWD_EMAIL_SENT_TEXT' | translate }}</div>

<div class="modal-footer d-flex justify-content-center">
    <button class="btn btn-primary cta-blue info-btn" (click)="ok()">{{ 'OK' | translate }}</button>
</div>